import { defineComponent as _defineComponent } from 'vue'
import { IProductPopularity } from 'JS/types/PDP';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPopularity',
  props: {
    productPopularity: null
  },
  setup(__props: any) {




return { __sfc: true, }
}

})